import { directusApi, PaginatedCollection } from '@/api';
import moment from 'moment-timezone';

export interface Feedback {
    id?: number;
    text: string;
    user: string;
    created_at: string;
}

export interface FeedbackState {
    allFeedbacks: Array<Feedback>;
    allFeedbacksLoading: boolean;

    activeFeedback: Feedback | null;
    activeFeedbackLoading: boolean;
    feddbacksPerPage: number;
    feddbacksPage: number;
    feddbacksTotal: number;
}

const state: FeedbackState = {
    allFeedbacks: [],
    allFeedbacksLoading: false,

    activeFeedback: {
        id: 0,
        text: '',
        user: '',
        created_at: '',
    },
    activeFeedbackLoading: false,
    feddbacksPerPage: 0,
    feddbacksPage: 0,
    feddbacksTotal: 0,
};

const mutations = {
    toggleAllFeedbacksLoading(state: FeedbackState, data: boolean) {
        state.allFeedbacksLoading = data;
    },
    setAllFeedbacks(state: FeedbackState, data: PaginatedCollection) {
        state.allFeedbacks = data.items;
        state.feddbacksPerPage = data.perPage;
        state.feddbacksPage = data.currentPage;
        state.feddbacksTotal = data.totalItems;
    },
    toggleActiveFeedbackLoading(state: FeedbackState, data: boolean) {
        state.activeFeedbackLoading = data;
    },
    setActiveFeedback(state: FeedbackState, data: Feedback) {
        state.activeFeedback = data;
    },
};

const actions = {

    async postOne({ _, commit, dispatch }: any, { data }: any) {
        commit('toggleActiveFeedbackLoading', true);
        data = { ...data, created_at: moment().format('YYYY-MM-DD H:mm:ss') }
        let endpoint: string = `items/feedback_system`;
        await directusApi('POST', endpoint, data)
            .then(async (feedback: any) => {
                console.log(feedback);
                commit('setActiveFeedback', feedback.data.data);
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('toggleActiveFeedbackLoading', false);
            });
    },
    
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
